const orderActionTypes = {
  RELEASE: 'release',
  CANCEL: 'cancel',
  ARCHIVE: 'archive',
  LOST_IN_PROCESS: 'lost_in_process',
  DONE_ORDER: 'done_order',
  CHECK_AVAILABILITY: 'checkAvailability',
  PART_BOX: 'part_box',
  PICKED: 'picked',
  PACK_BOX: 'pack_box',
  ORDER_LABEL: 'order_label',
  ORDER_TO_OVERSTOCK: 'order_to_overstock',
};
export default orderActionTypes;
